import { useTranslation } from 'react-i18next'

import { Divider } from '../../../../../Divider'
import { Status, STATUS_SIZE_20 } from '../../../../../Status'
import {
  APPLICANT_DOCUMENT_STATUS,
  QA_NAME_APPLICANT_CHECKLIST_STATUS,
} from '../ApplicantDocumentChecklist.constants'
import {
  getApplicantDocumentStatusProps,
  getIsApplicantDocumentVerdictLoading,
} from '../ApplicantDocumentChecklist.utils'

import { ApplicantDocumentChecklistAuditCell } from './ApplicantDocumentChecklistAuditCell'
import { ApplicantDocumentChecklistFileCell } from './ApplicantDocumentChecklistFileCell'
import { ApplicantDocumentChecklistRejectCell } from './ApplicantDocumentChecklistRejectCell'
import { ApplicantDocumentChecklistTypeCell } from './ApplicantDocumentChecklistTypeCell'
import { ApplicantDocumentChecklistVerifyCell } from './ApplicantDocumentChecklistVerifyCell'

import * as styles from './ApplicantDocumentChecklistRow.module.css'

function ApplicantDocumentChecklistRow({
  isAttaching,
  isLocked,
  isSubmitting,
  row,
  submittingStatus,
  verdictState,
  onAttach,
  onClickFile,
  onReject,
  onVerify,
}) {
  const { t } = useTranslation()

  const actionTooltip = verdictState.tooltipKey
    ? t(verdictState.tooltipKey)
    : null

  const isActionDisabled = Boolean(verdictState.tooltipKey) || isLocked

  function handleClickVerify() {
    onVerify(row)
  }

  function handleClickReject() {
    onReject(row)
  }

  return (
    <>
      <Divider className={styles.divider} />
      <ApplicantDocumentChecklistTypeCell row={row} />
      <Status
        {...getApplicantDocumentStatusProps({ row, t })}
        className={styles.status}
        height={STATUS_SIZE_20}
        qaName={QA_NAME_APPLICANT_CHECKLIST_STATUS}
      />
      <ApplicantDocumentChecklistFileCell
        file={row.file}
        onClickFile={onClickFile}
      />
      <ApplicantDocumentChecklistAuditCell row={row} />
      <ApplicantDocumentChecklistVerifyCell
        canVerify={verdictState.canVerify}
        disabled={isActionDisabled}
        isLoading={getIsApplicantDocumentVerdictLoading({
          isSubmitting,
          status: APPLICANT_DOCUMENT_STATUS.verified,
          submittingStatus,
        })}
        tooltip={actionTooltip}
        onClick={handleClickVerify}
      />
      <ApplicantDocumentChecklistRejectCell
        attachTooltip={
          verdictState.attachTooltipKey
            ? t(verdictState.attachTooltipKey)
            : null
        }
        canAttach={verdictState.canAttach}
        canReject={verdictState.canReject}
        disabled={isActionDisabled}
        isAttaching={isAttaching}
        isLoading={getIsApplicantDocumentVerdictLoading({
          isSubmitting,
          status: APPLICANT_DOCUMENT_STATUS.rejected,
          submittingStatus,
        })}
        isLocked={isLocked}
        row={row}
        tooltip={actionTooltip}
        onAttach={onAttach}
        onClick={handleClickReject}
      />
    </>
  )
}

export default ApplicantDocumentChecklistRow
